import { ComponentType, useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'

export function withRouter<T>(
	Component: ComponentType<T>,
): (props: Omit<T, 'router'>) => React.ReactElement<T & WithRouterProps> {
	function ComponentWithRouterProp(props: T) {
		const location = useLocation()
		const navigate = useNavigate()
		const params = useParams()

		return (
			<Component {...props} router={useMemo(() => ({ location, navigate, params }), [location, navigate, params])} />
		)
	}

	return ComponentWithRouterProp
}

export type WithRouterProps<T extends string | Record<string, string | undefined> = string> = {
	router: {
		location: ReturnType<typeof useLocation>
		navigate: ReturnType<typeof useNavigate>
		params: ReturnType<typeof useParams<T>>
	}
}
